import React, { Component } from 'react';
import { Footer, Header, LinkList } from '../../components';
import './style.scss';

class Home extends Component {
  constructor(props){
    super(props);
    this.state = {

     }
}

  render(){

    return(
      <div className="home">
      <Header home={true} />
      <LinkList home={true} />
      <div className="container">
        <div className="row" />
      </div>
      <Footer />
    </div>
    )
  }
}

export default Home;
